var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1858_3600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.933119 12.3506C0.932538 14.4511 1.48137 16.5021 2.52498 18.3098L0.833313 24.4864L7.15424 22.829C8.90253 23.7808 10.8614 24.2795 12.8519 24.2796H12.8572C19.4284 24.2796 24.7775 18.9324 24.7803 12.36C24.7816 9.17525 23.5424 6.18048 21.2911 3.92738C19.0401 1.67447 16.0464 0.433094 12.8567 0.431641C6.28467 0.431641 0.935929 5.77854 0.933216 12.3506",
    fill: "url(#paint0_linear_1858_3600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.103682 12.3465C0.103004 14.5226 0.671512 16.6469 1.75233 18.5194L0 24.9173L6.54758 23.2006C8.35165 24.1842 10.3828 24.7028 12.4497 24.7036H12.455C19.262 24.7036 24.8033 19.1641 24.8062 12.3564C24.8074 9.05717 23.5236 5.95475 21.1919 3.62093C18.8598 1.2874 15.759 0.00135659 12.455 0C5.6469 0 0.106395 5.53876 0.103682 12.3465ZM4.00291 18.1969L3.75843 17.8088C2.73072 16.1747 2.18828 14.2863 2.18905 12.3473C2.19128 6.68886 6.79632 2.08527 12.4589 2.08527C15.2012 2.08643 17.7783 3.15543 19.7167 5.09496C21.6549 7.03469 22.7215 9.61318 22.7208 12.3556C22.7183 18.0141 18.1132 22.6182 12.455 22.6182H12.451C10.6086 22.6172 8.80174 22.1225 7.22597 21.1875L6.85097 20.9651L2.9655 21.9838L4.00291 18.1968V18.1969Z",
    fill: "url(#paint1_linear_1858_3600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36803 7.18495C9.13683 6.67109 8.89352 6.66072 8.67365 6.65171C8.49361 6.64396 8.2878 6.64454 8.08218 6.64454C7.87636 6.64454 7.54196 6.72196 7.25931 7.03059C6.97636 7.3395 6.17908 8.08601 6.17908 9.60433C6.17908 11.1227 7.28499 12.5901 7.43915 12.7962C7.59352 13.0019 9.57413 16.2174 12.711 17.4544C15.3179 18.4824 15.8485 18.278 16.4143 18.2264C16.9801 18.1751 18.2402 17.4801 18.4973 16.7595C18.7546 16.0389 18.7546 15.4213 18.6774 15.2922C18.6003 15.1636 18.3945 15.0864 18.0859 14.9321C17.7771 14.7778 16.2599 14.0312 15.977 13.9282C15.6941 13.8253 15.4884 13.7739 15.2826 14.0829C15.0768 14.3914 14.4858 15.0864 14.3056 15.2922C14.1257 15.4985 13.9455 15.5242 13.637 15.3698C13.3282 15.215 12.3343 14.8895 11.1551 13.8382C10.2377 13.0202 9.61832 12.01 9.43828 11.701C9.25824 11.3925 9.419 11.2253 9.57375 11.0715C9.71241 10.9332 9.88247 10.7111 10.0369 10.531C10.1908 10.3507 10.2422 10.2222 10.3451 10.0163C10.4481 9.81034 10.3965 9.6301 10.3195 9.47574C10.2422 9.32138 9.64245 7.79512 9.36803 7.18495Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1858_3600",
    x1: 12.8068,
    y1: 24.4864,
    x2: 12.8068,
    y2: 0.431641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1858_3600",
    x1: 12.4031,
    y1: 24.9173,
    x2: 12.4031,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1858_3600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.fa440186c20e351a152eb97cdecfe618.svg";
export { ForwardRef as ReactComponent };